import { useState } from "react";
import { Copy, KeyRound, MailCheck, MailWarning, ShieldAlert, X } from "lucide-react";

function CopyValue({ label, testId, value }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  }
  return (
    <div className="secret-row team-secret-row">
      <strong>{label}</strong>
      <code data-testid={testId}>{value}</code>
      <button className="button button-secondary" data-testid={`${testId}-copy`} type="button" onClick={copy}>
        <Copy size={14} /> {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
}

export const TeamCredentialResult = ({ mode, onClose, result }) => (
  <section className="inline-edit-panel team-member-panel" data-testid="team-credential-panel">
    <div className="section-heading">
      <div>
        <h2>{mode === "create" ? "Account created" : "Password reset"}</h2>
        <p>
          {result.member.first_name} {result.member.last_name} · {result.member.email}
        </p>
      </div>
      <button
        aria-label="Close credential panel"
        className="projection-icon-button"
        data-testid="close-team-credential-panel"
        type="button"
        onClick={onClose}
      >
        <X size={16} />
      </button>
    </div>
    <div className="team-credential-body">
      {result.welcome_email_sent ? (
        <p className="team-email-status team-email-sent" data-testid="team-welcome-email-sent">
          <MailCheck size={15} /> Welcome email sent to {result.member.email} with the sign-in link and temporary
          password.
        </p>
      ) : (
        <p className="team-email-status team-email-failed" data-testid="team-welcome-email-failed">
          <MailWarning size={15} /> Welcome email could not be delivered
          {result.welcome_email_error ? ` (${result.welcome_email_error})` : ""}. Share the details below securely.
        </p>
      )}
      <CopyValue label="Sign-in email" testId="team-credential-email" value={result.member.email} />
      <CopyValue label="Temporary password" testId="team-credential-password" value={result.temporary_password} />
      <p className="team-credential-note" data-testid="team-credential-note">
        <ShieldAlert size={15} /> Shown once here. They will be asked to choose a new password the first time they sign
        in.
      </p>
      <button className="button button-primary" data-testid="team-credential-done-button" type="button" onClick={onClose}>
        <KeyRound size={15} /> Done
      </button>
    </div>
  </section>
);
